<div class="user-location-map">
  <div class="container-multiselect">
    <ng-select
      [items]="dropdownList"
      bindLabel="name"
      bindValue="id"
      (ngModelChange)="onSelectionChanged($event)"
      [multiple]="true"
      [(ngModel)]="selectedCountriesList"
      [placeholder]="'Select or Search Countries'"
      [notFoundText]="'Country not found'">
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label">{{ item.name }}</span>
        <span
          class="ng-value-icon right"
          (click)="toggleCountry(item.name)"
          aria-hidden="true">
          ×
        </span>
      </ng-template>
    </ng-select>
  </div>
  <div class="leaflet-container">
    <div
      class="leaflet-map"
      leaflet
      [leafletLayers]="markers"
      [leafletOptions]="options"
      [leafletZoomOptions]="false"
      (leafletMapReady)="onMapReady($event)"></div>
  </div>
</div>
